module.exports = __webpack_public_path__ + "img/who-we-are-home.c3fddae8.png";